import { useMemo } from 'react';

import { capitalize } from 'lodash';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, duplicateAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import DeleteEntityWithReferences from './DeleteEntityWithReferences';
import LanderFormatter from './LanderFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('type', 'Type', info => capitalize(info.getValue())),
    column.accessor('lander', {
      header: 'Lander',
      cell: info => <LanderFormatter info={info} />,
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction),
  ], [])
}

function deleteAction(info) {
  return <DeleteEntityWithReferences key={keyOf(info, 'delete')} info={info} />
}
